module.exports = __webpack_public_path__ + "static/media/vspaceteam-mobile.d6544785.png";